enum SignalRGroupType {
  JobUpdateChannel = 'jobUpdatesChannel',
  JobActivity = 'activityUpdate',
  SpreadingJobUpdate = 'spreadingJobUpdate',
  DigestateJobUpdate = 'digestateJobUpdate',
  HaulageJobUpdate = 'haulageJobUpdate'
}

export default SignalRGroupType
